import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@/components/ui";
import Seo from "@/components/Seo";
import { ImmersiveShell } from "@/components/immersive/ImmersiveShell";
import { Reveal } from "@/components/immersive/Reveal";
import Breadcrumbs from "@/components/immersive/Breadcrumbs";
import { CtaCluster } from "@/components/immersive/MarketingBits";
import { MATCH_STEPS } from "@/lib/content";

const INTRO = "Finding home care should not mean calling agency after agency. Here is how HomecareMatches helps families find in-home care through partner agencies — from your first request to your first day of service.";

export default function HowItWorks() {
  const ld = {
    "@context": "https://schema.org", "@type": "HowTo", "name": "How HomecareMatches Works",
    "step": MATCH_STEPS.map((s, i) => ({ "@type": "HowToStep", position: i + 1, name: s.title, text: s.desc })),
  };
  return (
    <ImmersiveShell>
      <Seo title="How It Works" path="/how-it-works"
        description="How HomecareMatches works: tell us your needs, we contact partner home-care agencies, identify a potential caregiver match, connect you, and help schedule your first day of care."
        keywords="how it works, senior care matching, caregiver matching, home care services, in-home care" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(ld) }} />
      <section className="imm-mkt-hero imm-wrap" data-testid="how-it-works">
        <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "How It Works" }]} />
        <Reveal className="imm-eyebrow" delay={80}>The process</Reveal>
        <Reveal as="h1" delay={180}>How HomecareMatches Works</Reveal>
        <Reveal as="p" delay={320}>{INTRO}</Reveal>
      </section>

      <section className="imm-wrap" data-testid="hiw-steps" style={{ paddingBottom: "6vh" }}>
        {MATCH_STEPS.map((s, i) => (
          <Reveal key={i} delay={i * 60}><div className="imm-feature"><span className="fnum">{String(i + 1).padStart(2, "0")}</span><div><h2 className="imm-svc-h2">{s.title}</h2><p>{s.desc}</p></div></div></Reveal>
        ))}
        <Reveal delay={120}><p style={{ marginTop: 20 }}><Link className="imm-inline-link" to="/faqs">Read FAQs about home care services <Icon name="arrow-right" size={15} /></Link></p></Reveal>
      </section>

      <section className="imm-wrap" data-testid="hiw-cta" style={{ paddingBottom: "8vh" }}>
        <Reveal as="h2" className="imm-svc-h2">Ready to start?</Reveal>
        <Reveal delay={80}><div style={{ marginTop: 18 }}><CtaCluster showPromo /></div></Reveal>
      </section>
    </ImmersiveShell>
  );
}
